import { Instance, SnapshotIn, types } from "mobx-state-tree";
import { withSetPropAction } from "mobx-stores/_extension/with-set-props";
import { Base, Catalogue } from "../base";
import { ContactInformation } from "./contact-information";
import { DeliveryAddress } from "./delivery-address";

export const Customer = types
  .compose(
    Base,
    types.model({
      name: types.string,
      code: types.string,
      taxCode: types.maybeNull(types.string),
      customerTypeId: types.maybeNull(types.string),
      headOfficeAddress: types.maybeNull(types.string),
      dealingName: types.maybeNull(types.string),
      note: types.maybeNull(types.string),
      customerType: types.maybeNull(Catalogue),
      deliveryAddresses: types.optional(types.array(DeliveryAddress), []),
      orderNumber: types.maybeNull(types.number),
      isDisabled: types.maybeNull(types.boolean),
    })
  )
  .actions(withSetPropAction);
export interface ICustomer extends Instance<typeof Customer> {}
export interface ICustomerProperties extends SnapshotIn<typeof Customer> {}

export const CustomerDetail = types.compose(
  Customer,
  types.model({
    contactInformations: types.optional(types.array(ContactInformation), []),
  })
);
export interface ICustomerDetail extends Instance<typeof CustomerDetail> {}
export interface ICustomerDetailProperties
  extends SnapshotIn<typeof CustomerDetail> {}
